import axios from 'axios';

import IAddCreditsPayload from '../types/IAddCreditsPayload';

export const getWorkspaceRecruiterSuggestions = (queryString: string) =>
  axios.get(
    `recruitersearch/api/recruiters/suggestions/recruiters-in-workspace?query=${queryString}`
  );
export const getTotalMailingCreditsAllotted = () =>
  axios.get('vendorsearch/api/mailingcredits/total-allotted');

export const getDefinedCreditsForWorkspaceUsers = () =>
  axios.get('vendorsearch/api/mailingcredits/defined-for-workspace-users');

export const addCreditsToWorkspaceUser = (payload: IAddCreditsPayload) =>
  axios.post('vendorsearch/api/mailingcredits', payload);

export const deleteAssignedCredsToWorkspaceUser = (email: string) =>
  axios.delete(`vendorsearch/api/mailingcredits?email=${email}`);

export const resetToDefaultMailingsCredits = () =>
  axios.put('vendorsearch/api/mailingcredits/reset-to-default-model');

export const getMassMailingCredsPerDay = () =>
  axios.get('api/plan/feature/stats?featureCodes=VS_MASS_MAILING_PER_DAY');

export const updateConsumedBroadcastQuota = (count: number) =>
  axios.put(`vendorsearch/api/mailingcredits/consumed/${count}`);
